import { Card } from '@/components/ui/Card';
import { Table, THead, TBody, TR, TH, TD } from '@/components/ui/Table';
import { formatIDR, formatNumber } from '@/lib/format';
import type { TopProduct } from '@/lib/api/reports';

export function TopProductsTable({ products }: { products: TopProduct[] }) {
  if (products.length === 0) {
    return (
      <Card>
        <p className="text-small text-ink-subtle">Belum ada produk terjual.</p>
      </Card>
    );
  }
  const maxRevenue = Math.max(...products.map((p) => p.revenue), 1);
  return (
    <Card padding="none">
      <div className="p-6 pb-4 border-b border-line">
        <h3 className="text-subhead font-display font-semibold text-ink">Top 10 produk</h3>
        <p className="text-caption text-ink-subtle mt-1">By revenue (descending)</p>
      </div>
      <Table>
        <THead>
          <TR>
            <TH>#</TH>
            <TH>Produk</TH>
            <TH className="text-right">Qty</TH>
            <TH className="text-right">Revenue</TH>
            <TH className="w-1/3">Distribution</TH>
          </TR>
        </THead>
        <TBody>
          {products.map((p, idx) => {
            const pct = (p.revenue / maxRevenue) * 100;
            return (
              <TR key={p.productId}>
                <TD>
                  <span className="text-overline uppercase text-ink-subtle font-medium">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </TD>
                <TD>
                  <p className="font-medium text-ink">{p.name}</p>
                </TD>
                <TD className="text-right tabular-nums">{formatNumber(p.qty)}</TD>
                <TD className="text-right tabular-nums font-medium">
                  {formatIDR(p.revenue)}
                </TD>
                <TD>
                  <div className="h-1.5 rounded-full bg-line/30 overflow-hidden">
                    <div
                      className="h-full bg-primary rounded-full"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </TD>
              </TR>
            );
          })}
        </TBody>
      </Table>
    </Card>
  );
}
